import { Component } from '@angular/core';

@Component({
  selector: 'app-user-pending',
  templateUrl: './user-pending.component.html',
  styleUrls: ['./user-pending.component.sass']
})
export class UserPendingComponent {
  title = 'MENU.PENDING-PATIENTS';
}
